import { createFileRoute } from "@tanstack/react-router"

import { pageHead } from "@/lib/metadata"
import { UnsubscribeFlow } from "@/components/layout/unsubscribe-frame"

const ID_PATTERN = /^[a-f0-9]{24}$/i

/** Mirrors `app/(site)/status/unsubscribe/page.tsx`. */
function NewsUnsubscribePage() {
  const { id, token, state } = Route.useSearch()

  return (
    <UnsubscribeFlow
      state={state}
      action="/api/news/unsubscribe"
      fields={id && ID_PATTERN.test(id) && token ? { id, token } : null}
      back={{ href: "/news", label: "Back to news" }}
      copy={{
        ask: "Stop news emails?",
        done: "You’re unsubscribed.",
        doneBody: "No more news emails will be sent to that address.",
      }}
    />
  )
}

export const Route = createFileRoute("/news/unsubscribe")({
  validateSearch: (
    search: Record<string, unknown>
  ): { id?: string; token?: string; state?: string } => ({
    id: typeof search.id === "string" ? search.id : undefined,
    token: typeof search.token === "string" ? search.token : undefined,
    state: typeof search.state === "string" ? search.state : undefined,
  }),
  head: () =>
    pageHead({
      title: "Stop news emails",
      description: "Stop receiving Anysola news emails.",
      path: "/news/unsubscribe",
      index: false,
      extraMeta: [{ name: "referrer", content: "no-referrer" }],
    }),
  component: NewsUnsubscribePage,
})
